import {SET_DB_DATA} from '../../actionTypes';

export const set_db_data = data => ({
	type: SET_DB_DATA,
	data
});
